module.exports = __webpack_public_path__ + "assets/4d4e765e905e0137183cb91a4027b76b.mp3";